import React from 'react';
import moment from 'moment';
import {
	getFormattedPercentage,
	getFormattedSpendWithSymbol,
} from 'utils/number';
import {
	HeadlinesContainer,
	HeadlinesTitle,
	HeadlinesLabel,
	HeadlinesValue,
} from './TaxonomyPreview.styles';

export default ({
	currencySymbol,
	company,
	dateFrom,
	dateTo,
	spend,
	l4CategoriesCount,
	totalSpend,
	vendorsCount,
}) => {
	const period = `${moment(dateFrom).format('MMM YYYY')} - ${moment(
		dateTo
	).format('MMM YYYY')}`;
	return (
		<HeadlinesContainer>
			<HeadlinesTitle title={company}>{company}</HeadlinesTitle>

			<HeadlinesLabel>Time period</HeadlinesLabel>
			<HeadlinesValue>{period}</HeadlinesValue>

			<HeadlinesLabel>Total spend</HeadlinesLabel>
			<HeadlinesValue>
				{getFormattedSpendWithSymbol(totalSpend, currencySymbol)}
			</HeadlinesValue>

			<HeadlinesLabel>Direct spend</HeadlinesLabel>
			<HeadlinesValue>
				{getFormattedSpendWithSymbol(spend, currencySymbol)} ({getFormattedPercentage(
					(spend / totalSpend) * 100
				)})
			</HeadlinesValue>

			<HeadlinesLabel>Number of direct L4 categories</HeadlinesLabel>
			<HeadlinesValue>{l4CategoriesCount}</HeadlinesValue>

			<HeadlinesLabel>Number of direct vendors</HeadlinesLabel>
			<HeadlinesValue>{vendorsCount}</HeadlinesValue>
		</HeadlinesContainer>
	);
};
